import { render, staticRenderFns } from "./dialogRelatorioMenu.vue?vue&type=template&id=2d7048cd&scoped=true"
import script from "./dialogRelatorioMenu.vue?vue&type=script&lang=js"
export * from "./dialogRelatorioMenu.vue?vue&type=script&lang=js"
import style0 from "./dialogRelatorioMenu.vue?vue&type=style&index=0&id=2d7048cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7048cd",
  null
  
)

export default component.exports